import * as React from "react";

const RequestQuote: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M20.634 0v12.181a5.368 5.368 0 010 10.735V26H0V0h20.634zm-1.17 1.17H1.17v23.66h18.294v-2.044a5.367 5.367 0 010-10.475V1.17zM15.43 21.513v1.17H3.904v-1.17h11.525zm5.205-8.162a4.207 4.207 0 00-4.199 4.199 4.203 4.203 0 004.2 4.196 4.2 4.2 0 004.195-4.196 4.203 4.203 0 00-4.196-4.199zm2.37 2.09l.581.61-.308.293-2.643 2.5-.569.539-.289.276-.289-.276-.023-.023-1.475-1.394-.306-.293.579-.61.305.289.897.851.312.296.858-.812 2.064-1.957.305-.29zm-9.04 1.523v1.17H3.904v-1.17h10.06zm1.465-4.548v1.17H3.904v-1.17h11.525zM9.305 3.312c.182 0 .325.146.325.325v5.08a.324.324 0 01-.325.325H4.228a.326.326 0 01-.325-.325v-5.08c0-.179.147-.325.325-.325h5.077zm7.425 4.555v1.17h-5.148v-1.17h5.148zM7.147 3.94h-.361l-.013.312c-.64.046-1.245.396-1.245 1.121 0 .553.322.839.793 1.014l.348.13-.046.92a1.65 1.65 0 01-.822-.458l-.435.578c.286.267.724.53 1.225.566l-.013.292h.36l.014-.305c.64-.081 1.215-.475 1.215-1.196 0-.523-.338-.826-.819-1.004l-.289-.111.042-.884c.231.055.468.189.637.358l.377-.563c-.218-.214-.604-.396-.985-.448l.017-.322zm-.127 2.71c.16.072.335.186.335.417 0 .204-.127.331-.37.373l.035-.79zm-.276-1.751l-.036.767-.059-.023c-.168-.072-.302-.156-.302-.357 0-.241.147-.358.397-.387zm9.986-1.58v1.17h-5.148v-1.17h5.148z"
            />
        </svg>
    );
};

export default React.memo(RequestQuote);
